import { defaultEntityState } from '@core/state/entities/entity';
import {
  mergeEntityState,
  removeEntitiesByFilter,
  removeEntitiesWithIds,
} from '@core/state/entities/entity.helpers';
import { IAnnotationQuestion } from '@core/state/entities/annotation-question/annotation-question.entity';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import _ from 'lodash-es';
import { createReducer, on } from '@ngrx/store';
import { entityKey } from '@core/state/entities/entity-name-map';
import { mapFn } from '@core/actions/util';

export const annotationQuestionEntityReducer = createReducer(
  defaultEntityState<IAnnotationQuestion>(),
  on(
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.projectUpdated,
    (state, props) =>
      mergeEntityState(
        entityKey.annotationQuestions,
        state,
        props,
        (aq) => aq.projectId === props.projectId,
      ),
  ),
  on(
    projectDetailActions.created,
    projectDetailActions.annotationQuestionAddedSuccessfully,
    projectDetailActions.customAnnotationQuestionSavedSuccessfully,
    projectDetailActions.annotationQuestionEdited,
    projectDetailActions.registered,
    projectDetailActions.customAnnotationQuestionCopiedSuccessfully,
    (state, props) =>
      mergeEntityState(entityKey.annotationQuestions, state, props),
  ),
  on(projectDetailActions.annotationQuestionDeleted, (state, props) =>
    removeEntitiesWithIds(state, [props.annotationQuestionId]),
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(state, (annQ) => annQ.projectId === props.projectId),
  ),
  on(projectDetailActions.annotationQuestionRepositioned, (state, props) => {
    const movedAnnotationQuestion = state.byId[props.movedQuestionId];
    const parentAnnotationQuestion = mapFn(movedAnnotationQuestion.target?.parentId,
      (parentId) => parentId ? props.annotationQuestions.find(aq=>aq.id === parentId) : null);

    return ({
      ...state,
      allIds: _.union(
        (props.annotationQuestions.map(
          (aq) => aq.id,
        )) ?? [],
        state.allIds,
      ),
      ...(parentAnnotationQuestion ?
          {
            byId: {
              ...state.byId,
              [parentAnnotationQuestion.id]: parentAnnotationQuestion,
            },
          } :
          {}
      ),
    });
  }),
);
